import React from 'react';

const ActiveAscending = () => (
  <svg width="10" height="16" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 5l5-5 5 5H0z" fill="#000" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 11l5 5 5-5H0z" fill="#000" fillOpacity=".1" />
  </svg>
);

export default ActiveAscending;



// WEBPACK FOOTER //
// ./src/assets/react-icons/ActiveAscending.js